module.exports = __webpack_public_path__ + "static/img/055.cec31d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/055.png
// module id = H65c
// module chunks = 0